import { render, staticRenderFns } from "./PageLayoutSix.vue?vue&type=template&id=9eee9b8e&scoped=true&"
import script from "./PageLayoutSix.vue?vue&type=script&lang=js&"
export * from "./PageLayoutSix.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutSix.vue?vue&type=style&index=0&id=9eee9b8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eee9b8e",
  null
  
)

export default component.exports